var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPrivateClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 8.7907C0.5 11.2521 1.24791 12 3.7093 12H9.2907C11.7521 12 12.5 11.2521 12.5 8.7907V5.44186C12.5 2.98047 11.7521 2.23256 9.2907 2.23256H7.61628C7.27023 2.23256 7.24233 2.19907 7.05814 1.95349L6.22093 0.837209C5.83023 0.31814 5.52326 0 4.54651 0H3.7093C1.24791 0 0.5 0.747908 0.5 3.2093V8.7907ZM7.4 6.6C7.65191 6.33167 8 5.89708 8 5.5C8 4.67157 7.32843 4 6.5 4C5.67157 4 5 4.67157 5 5.5C5 5.89708 5.34809 6.33167 5.6 6.6C5.6 7.11364 5.19686 9.07006 5.05154 9.75856C5.02522 9.88329 5.12017 10 5.24765 10H7.75659C7.8828 10 7.97717 9.88467 7.95284 9.76083C7.82576 9.11409 7.48114 7.3303 7.4 6.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPrivateClosed);
export default __webpack_public_path__ + "static/media/folderPrivateClosed.44ed1a886845adf30e6cc6d97abb497d.svg";
export { ForwardRef as ReactComponent };